module.exports = __webpack_public_path__ + "img/icon_map_7_on_111.e580f32e.png";